// src/components/home/config/homeData.js
import planificadorsacOn from '../../../assets/PlanSAC_on.png';
import generadorOn from '../../../assets/cuestionador_on.png';
import planificadorOn from '../../../assets/PlanSAE_on.png';
import traductorOn from '../../../assets/traductor_on.png';
import dashboardOn from '../../../assets/dashboard_on.png';
import planificadorsac from '../../../assets/PlanSAC.png';
import buscadorOn from '../../../assets/buscador_on.png';
import BiblioLBOn from '../../../assets/BiblioLB_on.png';
import generador from '../../../assets/cuestinador.png';
import resumen2On from '../../../assets/InfoEdu_on.png';
import planificador from '../../../assets/PlanSAE.png';
import traductor from '../../../assets/traductor.png';
import dashboard from '../../../assets/dashboard.png';
import buscador from '../../../assets/buscador.png';
import BiblioLB from '../../../assets/BiblioLB.png';
import resumen2 from '../../../assets/InfoEdu.png';

// Mantener en false para ocultar estas herramientas sin eliminar su configuración.
export const HERRAMIENTAS_DOCENTE_HABILITADAS = false;

const herramientasDocente = [
  {
    title: 'Traductor',
    eyebrow: 'Módulo Herramientas al docente',
    icon: traductor,
    iconOn: traductorOn,
    route: '/traductor',
    info:
      'Traduce contenidos educativos de forma rápida y precisa, facilitando el acceso al conocimiento en múltiples idiomas sin perder sentido pedagógico.',
  },
  {
    title: 'Generador de cuestionarios',
    eyebrow: 'Módulo Herramientas al docente',
    icon: generador,
    iconOn: generadorOn,
    route: '/cuestionario',
    info:
      'Crea cuestionarios alineados a tus objetivos de aprendizaje, con preguntas claras y pertinentes que te ayudan a evaluar de manera eficiente y significativa.',
  },
  {
    title: 'Resumen y cuestionario de documentos',
    eyebrow: 'Módulo Herramientas al docente',
    icon: resumen2,
    iconOn: resumen2On,
    route: '/resumenlibro',
    info:
      'Transforma documentos extensos en resúmenes claros y cuestionarios interactivos, ideales para estudiar, reforzar contenidos y promover el pensamiento crítico.',
  },
  {
    title: 'Biblioteca de Libros Resumidos',
    eyebrow: 'Módulo Herramientas al docente',
    icon: BiblioLB,
    iconOn: BiblioLBOn,
    route: '/resumen-biblioteca',
    info:
      'Selecciona un libro y accede a su contenido en 2 formatos de resumen: breve o completo, además de un cuestionario diseñado para reforzar la comprensión y profundizar en las ideas clave.',
  },
];

export function getHomeData(role) {
  // 1. Array base (Visible para TODOS los roles: Docentes, Directores, Admins)
  const base = [
    {
      title: 'Sesiones de Aprendizaje SAC',
      eyebrow: 'Módulo planificador de sesiones',
      icon: planificadorsac,
      iconOn: planificadorsacOn,
      route: `/${role}/sac`,
      info:
        'Diseña sesiones de aprendizaje contextualizadas que conectan el currículo con la realidad del estudiante, integrando competencias, desempeños y situaciones significativas de forma clara y ordenada.',
    },
    {
      title: 'Buscador de sesiones',
      eyebrow: 'Módulo planificador de sesiones',
      icon: buscador,
      iconOn: buscadorOn,
      route: `/${role}/buscador`,
      info:
        'Explora, adapta y reutiliza sesiones de aprendizaje validadas, ahorrando tiempo y fortaleciendo tu práctica docente con experiencias ya estructuradas.',
    },
    {
      title: 'Repositorio de sesiones',
      eyebrow: 'Módulo planificador de sesiones',
      icon: dashboard,
      iconOn: dashboardOn,
      route: `/${role}/dashboard`,
      info:
        "Visualiza un resumen centralizado de todas las sesiones generadas y aquellas que se encuentran en proceso.",
    },
  ];

  // 3. Elementos EXCLUSIVOS para el ADMIN (La creación de SAE)
  if (role === 'admin') {
    // Añade la SAE al principio de toda la lista (Posición 0)
    base.unshift({
      title: 'Sesiones de Aprendizaje SAE',
      eyebrow: 'Módulo planificador de sesiones',
      icon: planificador,
      iconOn: planificadorOn,
      route: `/${role}/sae`,
      info:
        'Planifica sesiones de aprendizaje estructuradas que sirven como base pedagógica para las SAC, asegurando coherencia curricular y calidad educativa.',
    });
  }

  if (HERRAMIENTAS_DOCENTE_HABILITADAS) {
    base.push(...herramientasDocente);
  }

  return base;
}
